import { colorsPalettes } from "@similarweb/styles";
import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { Box, Stack } from "@similarweb/ui-components/foundations";

const MessageLoaderVersion = () => {
    return (
        <Stack
            borderRadius="6px"
            border={`1px solid ${colorsPalettes.carbon[50]}`}
            gap="8px"
            padding="12px 16px"
            data-automation="message-loader"
        >
            <PixelPlaceholderLoader
                width="100%"
                height={14}
            />

            <PixelPlaceholderLoader
                width="100%"
                height={14}
            />
            <Box width="50%">
                <PixelPlaceholderLoader
                    width="100%"
                    height={14}
                />
            </Box>
        </Stack>
    );
};

export default MessageLoaderVersion;
